import { getFullName } from '../../gql/customerGql';
import { Deal, DealStateEnum, DealStateLabelMap, DealTypeLabelMap } from '../../gql/dealGql';
import { Deal as GeneratedDeal } from '../../gql/generated/graphql';

import TextNotificationBadgeV2 from '../../components/NotificationBadge/TextNotificationBadgeV2';
import { TableColumns } from '../../components/shared/Table/types';

import { formatDate, formatMoney } from '../../libs/utils';

type AnyDeal = Deal | GeneratedDeal;

export type DealWithNotifications = AnyDeal & {
  unseenNotificationsCount?: number;
};

export const completedDealColumns: TableColumns<DealWithNotifications> = [
  {
    header: '',
    getComponent: ({ item }) => <TextNotificationBadgeV2 count={item.unseenNotificationsCount} />,
    styleProps: { minW: '20px', maxW: '50px' },
  },
  {
    header: 'Completion Date',
    getComponent: ({ item }) =>
      item.completion_date_utc
        ? formatDate(item.completion_date_utc, item?.completion_date_tz)
        : '',
    styleProps: { minW: '135px' },
  },
  {
    header: 'Finalized Date',
    getComponent: ({ item }) =>
      item.deal_dates?.dates?.finalized ? formatDate(item.deal_dates.dates.finalized) : '',
    styleProps: { minW: '135px' },
  },
  {
    header: 'Type',
    getComponent: ({ item }) => (item.type ? DealTypeLabelMap[item.type] : ''),
    styleProps: { minW: '90px' },
  },
  {
    header: 'Name',
    getComponent: ({ item }) => (item.customer ? getFullName(item.customer) : ''),
    styleProps: { minW: '90px' },
  },
  {
    header: 'Year',
    getComponent: ({ item }) => item?.car?.year,
    styleProps: { minW: '90px' },
  },
  {
    header: 'Make',
    getComponent: ({ item }) => item?.car?.make,
    styleProps: { minW: '90px' },
  },
  {
    header: 'Model',
    getComponent: ({ item }) => item?.car?.model,
    styleProps: { minW: '90px' },
  },
  {
    header: 'VIN',
    getComponent: ({ item }) => item?.car?.vin,
    styleProps: { minW: '90px' },
  },
  {
    header: 'State',
    getComponent: ({ item }) => item?.customer?.address?.state,
    styleProps: { minW: '90px' },
  },
  {
    header: 'Advisor',
    getComponent: ({ item }) => item?.setter?.name,
    styleProps: { minW: '90px' },
  },
  {
    header: 'Financial Specialist',
    getComponent: ({ item }) => item?.closer?.name,
    styleProps: { minW: '165px' },
  },
  {
    header: 'Financial Specialist 2',
    getComponent: ({ item }) => item?.closer2?.name,
    styleProps: { minW: '170px' },
  },
  {
    header: 'Deal State',
    getComponent: ({ item }) => (item?.state ? DealStateLabelMap[item.state as DealStateEnum] : ''),
    styleProps: { minW: '95px' },
  },
  {
    header: 'Lienholder',
    getComponent: ({ item }) => item?.car?.payoff?.lienholder_name,
    styleProps: { minW: '95px' },
  },
  {
    header: 'Good Through Date',
    getComponent: ({ item }) =>
      item?.car?.payoff?.good_through_date
        ? formatDate(item?.car?.payoff?.good_through_date, 'utc')
        : '',
    styleProps: { minW: '90px' },
  },
  {
    header: 'Bank',
    getComponent: ({ item }) => item?.financial_info?.bank,
    styleProps: { minW: '90px' },
  },
  {
    header: 'Amount Financed',
    getComponent: ({ item }) => formatMoney(item?.financial_info?.amount_financed),
    styleProps: { minW: '90px' },
  },
];
